import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListClientGroupQueryVariables = Types.Exact<{
  input: Types.ListClientGroupInput;
}>;

export type ListClientGroupQuery = {
  __typename?: 'Query';
  listClientGroup: {
    __typename?: 'ListClientGroupResponse';
    items: Array<{
      __typename?: 'ListClientGroupResponsePayload';
      id: number;
      createdAt: string;
      uuid: string;
      name: string;
      orgName: string;
      totalUsers: number;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const ListClientGroupDocument = gql`
  query ListClientGroup($input: ListClientGroupInput!) {
    listClientGroup(input: $input) {
      items {
        id
        createdAt
        uuid
        name
        orgName
        totalUsers
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useListClientGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListClientGroupQuery,
    ListClientGroupQueryVariables
  > &
    (
      | { variables: ListClientGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListClientGroupQuery, ListClientGroupQueryVariables>(
    ListClientGroupDocument,
    options,
  );
}
export function useListClientGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListClientGroupQuery,
    ListClientGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListClientGroupQuery,
    ListClientGroupQueryVariables
  >(ListClientGroupDocument, options);
}
export function useListClientGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListClientGroupQuery,
        ListClientGroupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListClientGroupQuery,
    ListClientGroupQueryVariables
  >(ListClientGroupDocument, options);
}
export type ListClientGroupQueryHookResult = ReturnType<
  typeof useListClientGroupQuery
>;
export type ListClientGroupLazyQueryHookResult = ReturnType<
  typeof useListClientGroupLazyQuery
>;
export type ListClientGroupSuspenseQueryHookResult = ReturnType<
  typeof useListClientGroupSuspenseQuery
>;
export type ListClientGroupQueryResult = Apollo.QueryResult<
  ListClientGroupQuery,
  ListClientGroupQueryVariables
>;
export function refetchListClientGroupQuery(
  variables: ListClientGroupQueryVariables,
) {
  return { query: ListClientGroupDocument, variables: variables };
}
